import Immutable from 'seamless-immutable';
import ReducerContainer from '../../helper/reducer-helper';
import { mergeSameRuleDish } from '../../helper/dish-helper';
import actionTypes from '../../consts/goods-detail-action-type';
import commonActionTypes from '../../consts/common-action-type';
import { INDUSTRY } from '../../helper/const';

const initialState = Immutable.from({
  goodsDetail: null,
  dishesDataDuplicate: [],
  errorMessage: {},
  menuDataStatus: false,
  industry: INDUSTRY.NORMAL,
});

export default ReducerContainer.createReducer(initialState, {
  [actionTypes.SET_INDUSTRY_INFO]: (state, payload) => {
    return state.set('industry', payload);
  },

  [actionTypes.INIT_GOODS_DETAIL]: (state, payload) => {
    const goodsList = payload || [];

    if (!goodsList.length) {
      return state;
    }

    const currentGoodsList = state.dishesDataDuplicate.asMutable({ deep: true });
    const mergedGoodsMap = currentGoodsList.concat(goodsList).reduce((obj, cur) => {
      const { id } = cur;

      if (!obj.hasOwnProperty(id)) {
        obj[id] = cur;
      }
      return obj;
    }, {});

    const allGoods = Object.keys(mergedGoodsMap).map(key => mergedGoodsMap[key]);
    allGoods.sort((a, b) => a.marketPrice - b.marketPrice);

    const [currentGoods] = goodsList;
    const { dishList: sameRuleMergedGoodsList } = mergeSameRuleDish(allGoods, []);
    const [goods] = sameRuleMergedGoodsList.filter(item => item.id === currentGoods.id);

    return state.set('goodsDetail', goods).set('dishesDataDuplicate', sameRuleMergedGoodsList);
  },

  [actionTypes.INIT_ORDERED_DISHES]: (state, payload) => state.set('dishesDataDuplicate', payload || []),

  [actionTypes.SET_GOODS_DETAIL_WITH_RECOMMEND_LIST]: (state, payload) => {
    return state.set('dishesDataDuplicate', payload || []).set('menuDataStatus', true);
  },

  [commonActionTypes.SET_ERROR_MSG]: (state, payload) => state.set('errorMessage', payload || []),
});



// WEBPACK FOOTER //
// ./src/reducer/goods-detail/index.js